import { useState, useCallback, useEffect } from 'react';
import { EventData, EVENTS, STATUS, Step } from 'react-joyride';

const TOUR_KEY = 'solimat-communications-tour-v1';

const STEPS: Step[] = [
  {
    target: '.comms-list',
    title: 'Panel de comunicaciones',
    content: 'Aquí se muestran todos los hilos de comunicación con Solimat. Puedes ver el estado de cada mensaje y acceder al detalle de cada conversación.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '.tabs',
    title: 'Pestañas de estado',
    content: 'Filtra las comunicaciones por estado: activas, resueltas, etc. El número en cada pestaña indica los hilos en ese estado.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.comms-filters',
    title: 'Filtros de búsqueda',
    content: 'Busca comunicaciones por texto o filtra por fecha para localizar rápidamente un hilo de conversación concreto.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '.comms',
    title: 'Lista de comunicaciones',
    content: 'Cada tarjeta representa un hilo de comunicación con el asunto, el último mensaje y la fecha. Haz clic en cualquiera para ver el hilo completo y responder.',
    placement: 'top',
    skipBeacon: true,
  },
  {
    target: '[data-tour="comms-create-btn"]',
    title: 'Crear nueva comunicación',
    content: 'Usa este botón para iniciar una nueva comunicación con tu gestor asignado por Solimat. Podrás adjuntar archivos y describir tu consulta o trámite.',
    placement: 'bottom',
    skipBeacon: true,
  },
];

const BASE_STEPS = STEPS.slice(0, 5);
const ALL_STEPS = STEPS;

export const useCommunicationsTour = (canCreate: boolean) => {
  const [run, setRun] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  const steps = canCreate ? ALL_STEPS : BASE_STEPS;

  const handleCallback = useCallback((data: EventData) => {
    const { type, status, index } = data as any;
    const finished = status === STATUS.FINISHED || status === STATUS.SKIPPED;

    if (finished || (type as string) === EVENTS.TOUR_END) {
      setRun(false);
      localStorage.setItem(TOUR_KEY, 'true');
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }

    if ((type as string) === EVENTS.STEP_AFTER && index === 0) {
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }
  }, []);

  const startTour = useCallback(() => {
    setRun(current => {
      if (current) return false;
      setTourKey(k => k + 1);
      return true;
    });
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: run } }));
  }, [run]);

  return { run, tourKey, steps, handleCallback, startTour };
};
